import { SITE_DATA_LAYER_IDS } from '~/store2/siteDataLayers';

export const FIBER_LIT_BUILDINGS_LAYER_ID = 'fiberLitBuildings' as const;

/** Project-scoped layers with dedicated Surface renderers (not the MapLayers tile loop). */
export const PROJECT_SCOPED_RENDERER_LAYER_IDS: ReadonlySet<string> = new Set([
  FIBER_LIT_BUILDINGS_LAYER_ID,
  SITE_DATA_LAYER_IDS.fieldNotes,
  SITE_DATA_LAYER_IDS.potholes,
]);

export function isProjectScopedRendererLayer(layerId: string): boolean {
  return PROJECT_SCOPED_RENDERER_LAYER_IDS.has(layerId);
}

// FiberLitBuildingsLayer (the actual renderer) is only mounted inside a project
// (see pages/projectDetails/map/Surface.tsx), so its Mapbox layer does not exist
// in the map style outside one — registering its id there would make
// queryRenderedFeatures throw.
export function shouldRegisterFiberLitBuildingsLayer(
  visibleLayerIds: ReadonlySet<string>,
  projectId: string | undefined,
): boolean {
  return Boolean(projectId) && visibleLayerIds.has(FIBER_LIT_BUILDINGS_LAYER_ID);
}
